import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BusinessClient } from '@models/clients';
import { ClientsDispatch } from '@state/clients';
import { MatterClientDispatch } from '@state/matter_clients/matterClients.dispatch';
import { NavigationService } from 'src/app/shared/services/nav/nav.service';

@Component({
	selector: 'app-edit-business-client-side-form',
	templateUrl: './edit-business-client-side-form.component.html',
	standalone: false,
})
export class EditBusinessClientSideFormComponent implements OnInit {
	private isPrimary;

	@Input() client: BusinessClient;
	@Input() enableSigningOfficers = false;
	@Input() showPrimaryClientOption = false;
	@Input() primaryContact;

	constructor(
		private route: ActivatedRoute,
		private navigationService: NavigationService,
		private matterClientDispatch: MatterClientDispatch,
		private clientsDispatch: ClientsDispatch,
	) {}

	_onCreate(business: BusinessClient & { primary: boolean }) {
		this.clientsDispatch.CreateOrMerge(this.client.id, {
			name: business.name,
			phone: business.phone,
			fax: business.fax,
			email: business.email,
		});

		if (business.primary !== this.isPrimary) {
			this.matterClientDispatch.SetIsPrimary(business.id, business.primary);
		}
		this.navigationService.goBack(this.route);
	}

	ngOnInit(): void {
		this.isPrimary = this.primaryContact;
	}

	_onCancel() {
		this.navigationService.goBack(this.route);
	}
}
